import type { PaymentFlowVm, PaymentStage, ProgressPhase, ProgressVm } from './port/types'

/** Фаза содержимого источника → этап окна оплаты: несколько фаз — один этап, окно от этого не мигает. */
export const STAGE_OF_PHASE: Readonly<Record<ProgressPhase, PaymentStage>> = {
  sending: 'preparing',
  terminal: 'terminal',
  receipt: 'receipt',
  'money-unknown': 'checking',
  'command-unknown': 'checking',
  'receipt-unknown': 'receipt',
  'no-receipt': 'no-receipt',
}

/**
 * Этапы, в которых ход идёт сам и окно можно свернуть («Свернуть» → «Ход оплаты: …» в блоке состояния). Итог, отказ, «оплата не
 * началась» и ручная сверка ждут решения кассира — они не сворачиваются. Общее для всех источников.
 */
export const COLLAPSIBLE_PAYMENT_STAGES: ReadonlySet<PaymentStage> = new Set(['preparing', 'terminal', 'checking', 'receipt', 'no-receipt', 'late-slip'])

/** Поля окна оплаты, которых в содержимом источника нет: по умолчанию кнопок нет, окно не сворачивается. */
export type PaymentFlowExtras = Partial<Omit<PaymentFlowVm, 'attemptKey' | 'stage'>>

/**
 * Окно оплаты из содержимого хода источника: источник, который собирает тексты и кнопки чека как `ProgressVm` (AQSI), получает то же
 * окно; этап — по фазе, остальное — из `extras`. Этап и кнопки попытки источник решает сам (у собственной кассы — свой адаптер
 * `buildOwnPaymentFlow`, RP-PAY-ONE шаг 7).
 */
export function paymentFlowOfProgress(progress: ProgressVm, attemptKey: string, extras: PaymentFlowExtras = {}): PaymentFlowVm {
  const { phase, ...content } = progress
  return {
    ...content,
    watchNote: progress.watchNote ?? null,
    attemptKey,
    stage: STAGE_OF_PHASE[phase],
    waitingSince: null,
    collapsed: false,
    canCollapse: false,
    cancelling: false,
    repeat: null,
    alternative: null,
    canClose: false,
    latePayment: null,
    resolve: null,
    done: null,
    notice: null,
    ...extras,
  }
}
